import { LobbyEntryEdit } from './lobby-entry-edit';
import { debug } from 'util';
import { Service } from './lobby-service';

export class LobbyEntryDetailEdit extends LobbyEntryEdit {
  public addedTime?: string;
  public interactions?: LobbyInteractionDetailEdit[];
  public editReason?: string;
  public lwaReasonId?: number;
}

export class LobbyInteractionDetailEdit {
  public interactionId?: number;
  public assistedBy?: number;
  public assistTypeId?: number;
  public lobbyAddedLocalTime?: string;
  public assistedTime?: string;
  public completedTime?: string;
  public assistedLocalTime?: string;
  public completedLocalTime?: string;
  public servicesProvided?: LobbyServiceProvidedDetailEdit[];
}

export class LobbyServiceProvidedDetailEdit {
  public serviceProvidedId?: number;
  public referenceNumber?: string;
  public serviceId?: number | null;
  public serviceTime?: number;
  public serviceProvidedTime?: string;
  public serviceProvidedLocalTime?: string;
 
}

export class LobbyServiceProviderMapper {
  public servicesProvided?: LobbyServiceProvidedDetailView[];

}

export class LobbyEntryDetailView {
  private lobbyEntry: any;
  public completedLocalTime?: Date;
  public confirmationNumber: string;
  public servicesProvided: LobbyServiceProvidedDetailView[];
  public utcoffsetInMinutes: number = 0;
  get addedBy(): string {
    return this.lobbyEntry.addedBy.firstName + " " + this.lobbyEntry.addedBy.lastName;
  }

  //interactions
  get interactions(): LobbyInteractionDetailEdit[] {
    return this.lobbyEntry.lobbyInteractions.map((o: any) => {
        let lobbyInteraction = new LobbyInteractionDetailEdit();
        lobbyInteraction.interactionId = o.interactionId;
        lobbyInteraction.assistedBy = o.assistedBy.userId;
        lobbyInteraction.assistTypeId = o.assistType.assistTypeId;
        lobbyInteraction.assistedTime = o.assistedLocalTime;
        lobbyInteraction.completedTime = o.completedLocalTime;
        lobbyInteraction.assistedLocalTime = o.assistedLocalTime;
        lobbyInteraction.completedLocalTime = o.completedLocalTime;
      lobbyInteraction.servicesProvided = o.lobbyServiceProvided.map((s: any) => {
          let lobbyServiceProvided = new LobbyServiceProvidedDetailEdit();
          lobbyServiceProvided.serviceProvidedId = s.serviceProvidedId
          lobbyServiceProvided.serviceId = s.serviceId;
          lobbyServiceProvided.referenceNumber = s.refferenceNumber;
          lobbyServiceProvided.serviceTime = Math.round(s.servicTime);
          lobbyServiceProvided.serviceProvidedTime = s.serviceProvidedTime?.split('.')[0];
          lobbyServiceProvided.serviceProvidedLocalTime = s.serviceProvidedLocalTime?.split('.')[0];
          
          let serviceProvidedView = this.getServiceProvidedView(s.serviceProvidedId);
          if (serviceProvidedView != null) {
            lobbyServiceProvided.serviceId = serviceProvidedView.serviceId;
            lobbyServiceProvided.referenceNumber = serviceProvidedView.referenceNumber;
          }
          return lobbyServiceProvided;
        });
        return lobbyInteraction;
    });
  }
  //checkInTime
  get checkInTime(): Date {
    return new Date(this.lobbyEntry.addedLocalTime.split('.')[0]);
  }
  //waitTime
  get waitTime(): string {
    var waitTimeInt = 0;
    const seenInteractions = new Set<number>();

    this.servicesProvided.forEach(o => {
      if (typeof o.interactionId === 'number' && !seenInteractions.has(o.interactionId)) {
        waitTimeInt += o.waitTimeInt || 0;
        seenInteractions.add(o.interactionId);
      }
    });
    return LobbyCommonUtil.convertToTimeString(waitTimeInt);
  }
  //serviceTime
  get serviceTime(): string {
    var serviceTimeInt = 0;
    this.servicesProvided.forEach(o => {
      serviceTimeInt += Math.round(o.serviceTimeInt!);
    });
    return LobbyCommonUtil.convertToTimeString(serviceTimeInt);
  }
  //wrapUpTime
  get wrapUpTime(): string {
    var wrapUpTimeInt = 0;
    const seenInteractions = new Set<number>();
    this.servicesProvided.forEach(o => {
      if (typeof o.interactionId === 'number' && !seenInteractions.has(o.interactionId)) {
        wrapUpTimeInt += Math.round(o.wrapUpTimeInt!) || 0;
        seenInteractions.add(o.interactionId);
      }
    });
    return LobbyCommonUtil.convertToTimeString(wrapUpTimeInt);
  }
  //totalTime
  get totalTime(): string {
    var totalTimeInt = 0;
    this.servicesProvided.forEach(o => {
      totalTimeInt += o.totalTimeInt;
    });
    return LobbyCommonUtil.convertToTimeString(totalTimeInt);
  }

  constructor(lobbyEntry: any) {
    this.lobbyEntry = lobbyEntry;
    this.confirmationNumber = lobbyEntry.appointment != null ? lobbyEntry.appointment.confirmationNumber : "";
    this.servicesProvided = [];

    lobbyEntry.lobbyInteractions.forEach((li: any, index: any) => {
      let totalServiceTime = 0;
      let totalAssistTime = Math.floor(new Date(li.completedTime).getTime() / 1000) - Math.floor(new Date(li.assistedTime).getTime() / 1000);
      li.lobbyServiceProvided.forEach((sp: any, index2: any) => {
        totalServiceTime += Math.round(sp.servicTime);
        let spv = new LobbyServiceProvidedDetailView()
        spv.assistedBy = li.assistedBy;
        spv.assistedByName = li.assistedBy.firstName + ' ' + li.assistedBy.lastName;
        spv.serviceProvidedId = sp.serviceProvidedId;
        spv.serviceId = sp.serviceId;
        spv.serviceName = sp.serviceName;
        spv.referenceNumber = sp.refferenceNumber;
        spv.serviceTimeInt = Math.round(sp.servicTime);
        spv.serviceProvidedTime = new Date(sp.serviceProvidedLocalTime.split('.')[0]);
        spv.serviceStartedTime = new Date(sp.serviceAssistStartedLocalTime.split('.')[0]);
        spv.waitTimeInt = subtractDates(li.assistedTime,li.lobbyAddedTime);
        spv.wrapUpTimeInt = Math.round(li.wrapUpTime);
        spv.serviceCategoryName = sp.serviceCategoryName;
        spv.interactionId = li.interactionId;
        spv.completedLocalTime = new Date(li.completedLocalTime?.split('.')[0]);
        spv.lobbyAddedTime = new Date(li.lobbyAddedLocalTime?.split('.')[0]);
        spv.lobbyAssistedTime = new Date(li.assistedLocalTime?.split('.')[0]);
        this.servicesProvided.push(spv);
      });
      this.completedLocalTime = new Date(li.completedLocalTime.split('.')[0]);
      this.utcoffsetInMinutes = lobbyEntry.utcoffsetInMinutes;
    });
  }
  
  getServiceProvidedView(id: number): LobbyServiceProvidedDetailView {
    let item: LobbyServiceProvidedDetailView = {} as LobbyServiceProvidedDetailView;
    this.servicesProvided.forEach(o => {
      if (o.serviceProvidedId === id) {
        item = o;
        return;
      }
    });
    return item;
  }

  setServices (allServices: any) {
    this.servicesProvided.forEach(sp => {
      let serviceFound: boolean = false;
      let updatedServices = allServices.map((o: any) => {
        if (o.id == sp.serviceId)
          serviceFound = true;
        return o;
      });

      if (!serviceFound) {
        updatedServices.push({ id: sp.serviceId, name: sp.serviceName, categoryName: sp.serviceCategoryName });
      }

      updatedServices.sort((a: any, b: any) => a.name.localeCompare(b.name));
      sp.allServices = updatedServices;
    });
  }
}


export class LobbyServiceProvidedDetailView {
  public allServices: any;
  public assistedByName?: string;
  public serviceProvidedId?: number;
  public serviceId?: number | null;
  public serviceName?: string;
  public assistedBy?: AssistedMember ;
  public serviceProvidedTime?: Date | null;
  public serviceStartedTime?: Date | null;
  //public requested: boolean;
  public referenceNumber?: string;
  public waitTimeInt?: number|null;
  public serviceTimeInt?: number|null;
  public wrapUpTimeInt?: number|null;
  //serviceStartTime
  public serviceCategoryName?: string;
  public interactionId?: number | null;
  public completedLocalTime?: Date | null;
  public lobbyAddedTime?: Date | null;
  public lobbyAssistedTime?: Date | null;

  public errors?: {
    serviceId?: string;
    assistedBy?: string;
    serviceStartedTime?: string;
    waitTime?: string;
    serviceTime?: string;
    wrapUpTime?: string;
    assistStartedError?: string;
  };

  //waitTime
  get waitTime(): string {
    return LobbyCommonUtil.convertToTimeString(this.waitTimeInt!);
  }
  set waitTime(value: string) {
    this.waitTimeInt = LobbyCommonUtil.convertToTimeInt(value);
  }
  //serviceTime
  get serviceTime(): string {
    return LobbyCommonUtil.convertToTimeString(this.serviceTimeInt!);
  }
  set serviceTime(value: string) {
    this.serviceTimeInt = LobbyCommonUtil.convertToTimeInt(value);
  }
  //wrapUpTime
  get wrapUpTime(): string {
    return LobbyCommonUtil.convertToTimeString(this.wrapUpTimeInt!);
  }
  set wrapUpTime(value: string) {
    this.wrapUpTimeInt = LobbyCommonUtil.convertToTimeInt(value);
  }
  //totalTime
  get totalTimeInt(): number {
    return this.waitTimeInt! + this.serviceTimeInt! + this.wrapUpTimeInt!;
  }
  get totalTime() : string {
    return LobbyCommonUtil.convertToTimeString(this.totalTimeInt);
  }
}

export interface AssistedMember {
  userId: number| null ;
  firstName: string;
  lastName: string;
  isSpanishSpeaker: boolean;
  showInKiosk: boolean;
  showInLobby: boolean;
}


export class LobbyCommonUtil {
  static convertToTimeInt(value: string) {
    if (value.length === 6 && !value.includes(':')) {
      value = value.replace(/(\d{2})(\d{2})(\d{2})/, '$1:$2:$3');
    }

    let parts = value.split(':'); // split it at the colons
    if (parts.length !== 3 || parts.some(p => isNaN(+p))) {
      return null;
    }
    
    return (+parts[0]) * 60 * 60 + (+parts[1]) * 60 + (+parts[2]);
  }
  static convertToTimeString(value: number): string {
    let hours = Math.floor(value / 3600);
    let minutes = Math.floor((value - (hours * 3600)) / 60);
    let seconds = value - (hours * 3600) - (minutes * 60);
    let hoursString = hours.toString(), minutesString = minutes.toString(), secondsString = seconds.toString()

    if (hours < 10) { hoursString = "0" + hoursString; }
    if (minutes < 10) { minutesString = "0" + minutesString; }
    if (seconds < 10) { secondsString = "0" + secondsString; }
    return hoursString + ':' + minutesString + ':' + secondsString;
  }
}


export function subtractDates(date1:any, date2:any) {
      // Create new Date objects without milliseconds
  let dateStr=new Date(date1);
  let dateEnd=new Date(date2);
      let date1WithoutMilliseconds = new Date(dateStr.getFullYear(), dateStr.getMonth(), dateStr.getDate(), dateStr.getHours(), dateStr.getMinutes(), dateStr.getSeconds());
      let date2WithoutMilliseconds = new Date(dateEnd.getFullYear(), dateEnd.getMonth(), dateEnd.getDate(), dateEnd.getHours(), dateEnd.getMinutes(), dateEnd.getSeconds());
  

      let timestamp1 = date1WithoutMilliseconds.getTime();
      let timestamp2 = date2WithoutMilliseconds.getTime();
  
      // Subtract the timestamps
      let timeDifference = timestamp1-timestamp2;
  
      // Convert the time difference to a more readable format (e.g., total seconds)
      let totalSeconds = Math.round(timeDifference / 1000);
  
      return totalSeconds;
  
  }

  export function toLocalISOString(date: Date): string {
      const pad = (n: number) => n.toString().padStart(2, '0');
      const ms = date.getMilliseconds().toString().padStart(3, '0');

      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T` +
            `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${ms}`;
    }
  
